import { render, staticRenderFns } from "./FinalValueColumn.vue?vue&type=template&id=436b83a4&functional=true"
import script from "./FinalValueColumn.vue?vue&type=script&lang=js"
export * from "./FinalValueColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports